import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DOData, NJDocData } from "../DOData";
import { DocDefPrimLibService } from '../../doc-def-prim-lib.service';

@Component({
  selector: 'cylib-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.css']
})
export class DocumentUploadComponent implements OnInit
{
    customParameters: {};
    private maxUploads: number = 10;
    private maxAttachmentSize: number = 10000000;
    Style: any;
    LabelStyle: any;
    lstUploads: any;
    Label: string;
    uploadProgress: boolean = false;

    @Output() OutputMessage = new EventEmitter();
    @Output() DocUploadResult = new EventEmitter();




    private _ComponentData: DOData;
    @Input() public set ComponentData(t: DOData)
    {
        this._ComponentData = t;
        if (this._ComponentData)
            this.UpdateElement();
    }
    public get ComponentData(): DOData
    {
        return this._ComponentData;
    }

    private _loaderKey: string;
    @Input() public set loaderKey(t: string)
    {
        this._loaderKey = t;
    }
    public get loaderKey(): string
    {
        return this._loaderKey;
    }
    
    constructor(private svc: DocDefPrimLibService)
    {

    }

    ngOnInit()
    {

    }

    UpdateElement()
    {
        this.Style = [];
        this.LabelStyle = [];
        //this._UploadComponentData = new DataModel;
        //this._UploadComponentData.TemplateItem = this.ComponentData.TemplateItem;
        //this._UploadComponentData.Data = "UploadElement";
        //this._UploadComponentData.isValid = this.ComponentData.isValid;

        if (!this.lstUploads)
            this.lstUploads = [];

        //if (String(this.ComponentData.TemplateItem.Required) === "true")
        //    this.isRequired = true;

        this.Label = this.ComponentData.njDocDefTemplate.tLabel;

        this.customParameters = [];
        if (this.ComponentData.customParameters)
        {
            this.customParameters = this.ComponentData.customParameters;

            this.HandleCustomParams();
        }

        if (!this.ComponentData.isValid)
            this.Style['background-color'] = 'pink';
        else
            this.Style['background-color'] = 'none';
    }

    HandleCustomParams()
    {
        if (this.customParameters["MaxUploads"])
            this.maxUploads = this.customParameters["MaxUploads"];

        if (this.customParameters["MaxSize"])
            this.maxAttachmentSize = this.customParameters["MaxSize"];

        if (this.customParameters["LabelStyle"])
        {
            this.LabelStyle = this.customParameters["LabelStyle"];//Helpers.getStyles(this.customParameters["LabelStyle"]);
        }

    }
    uploadFiles(event: any)
    {
        if (event.target.files && event.target.files[0])
        {
            this.uploadProgress = true;
            if (event.target.files.length > this.maxUploads || this.UploadDoc.length >= this.maxUploads || this.UploadDoc.length + event.target.files.length > this.maxUploads)
            {
                alert("You have attached maximum number of documents allowed (" + this.maxUploads + "). If needed please submit in another request.");
                this.uploadProgress = false;
            }
            else
            {
                let _files = event.target.files;
                let lstFileNames = [];
                for (let i = 0; i < _files.length; i++)
                {
                    if (_files[i].size > this.maxAttachmentSize)
                    {
                        alert("Maximum file size exceeded.");
                        this.uploadProgress = false;
                        return;
                    }
                    else
                    {
                        let newFileName: string = this.generateNewUploadString(_files[i].name);
                        lstFileNames.push(newFileName);
                        this.svc.PrepareUpload(_files[i], newFileName, this.ComponentData.njDocDefTemplate.templateCode).subscribe(res =>
                        {
                            if (res.Errmsg)
                            {
                                alert(res.Errmsg);
                            }
                            else
                            {
                                //let _dm: DataModel = new DataModel;
                                //_dm.TemplateItem = new Templates();
                                //_dm.Row = this.svc.getRowNumber();
                                //_dm.Data = lstFileNames[i];
                                //_dm.TemplateItem.ParentElement = this.ComponentData.njDocDefTemplate.templateCode;
                                //_dm.TemplateItem.ElementType = "UploadDoc";
                                let _docNameOrig = lstFileNames[i].substring(lstFileNames[i].indexOf('.') + 1);
                                let _uploadedDoc: NJDocData = new NJDocData();
                                _uploadedDoc.dataValue = _docNameOrig;
                                _uploadedDoc.docDefTemplateID = this.ComponentData.njDocDefTemplate.docDefTemplateID;
                                this.UploadDoc.push(_uploadedDoc);
                                //let File: UploadGridVM = { DocNameOrig: _docNameOrig, DocNameNew: lstFileNames[i], Row: _dm.Row };
                                //this.lstUploads.push(File);
                                //if (this.lstUploads.length <= 1)
                                //    this.BuildGrid();
                                //else
                                //this.gridApi.setRowData(this.lstUploads);
                                //this.svc.AddDataToLoader(_dm);
                                
                                
                            }
                            this.uploadProgress = false;
                        });
                    }
                }
                this.DocUploadResult.emit(this.UploadDoc);
            }
        }
    }
    UploadDoc: Array<NJDocData> = new Array<NJDocData>();
    emitMessage(msg: string)
    {
        let appMessage: string = "";
        appMessage = msg;
        this.OutputMessage.emit(appMessage);    //(Helpers.getErrorMsg(appMessage));
    }

    startUpload()
    {
        //this.uploadProgress = true;
    }

    generateNewUploadString(fullFileName: string): string
    {
        var period = fullFileName.lastIndexOf('.');
        var fileName = fullFileName.substring(0, period);
        var fileExtension = fullFileName.substring(period + 1);

        let length: number = 10;
        let result: string = "";
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++)
        {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }

        return Date.now() + result + "." + fullFileName;
    }
    
    //grdUploadColDefs: any;
    //frameworkComponents: any;
    //context: any;
    //private gridApi;
    //gridStyle: any;
    //_UploadComponentData: DataModel;
    //isRequired: boolean = false;
    
    //BuildGrid()
    //{
    //    this.grdUploadColDefs = [];
    //    this.grdUploadColDefs.push({ headerName: "Remove", colID: "params", field: "Remove", resizable: true, cellRenderer: "CreateRemoveButtonsComponent" });
    //    this.grdUploadColDefs.push({ headerName: "Document Name", field: "DocNameOrig", resizable: true, editable: false });

    //    ////build grid columns from view model
    //    //for (var key in this.lstUploads[0])
    //    //{
    //    //  var obj = { headerName: key, field: key, editable: false };
    //    //  this.grdUploadColDefs.push(obj);
    //    //}

    //    this.gridApi.setRowData(this.lstUploads);

    //    this.gridStyle = { 'height': '200px' };
    //}

    //onGridReady(params)
    //{
    //    this.gridApi = params.api;

    //    let filt = this.ComponentData.TemplateItem.TemplateCode;
    //    let tempLstUploads: DataModel[] = this.Loader.ComponentData.filter(function (dm: DataModel)
    //    {
    //        return dm.TemplateItem.ParentElement == filt;
    //    });

    //    if (tempLstUploads.length > 0)
    //    {
    //        for (let i = 0; i < tempLstUploads.length; i++)
    //        {
    //            let _docNameOrig = tempLstUploads[i].Data.substring(tempLstUploads[i].Data.indexOf('.') + 1);
    //            this.lstUploads.push({ DocNameOrig: _docNameOrig, DocNameNew: tempLstUploads[i].Data, Row: tempLstUploads[i].Row });
    //        }
    //        this.BuildGrid();
    //    }


    //}

    //deleteRecord(index: any, RowID: any)
    //{
    //    this.uploadProgress = true;
    //    this.svc.DeleteAttachment(RowID).subscribe(res =>
    //    {
    //        this.lstUploads.splice(index, 1);
    //        this.svc.DeleteGridRow(RowID);
    //        this.gridApi.setRowData(this.lstUploads);
    //        this.uploadProgress = false;
    //    });
    //}

}

export class UploadGridVM
{
    DocNameOrig: string;
    DocNameNew: string;
    Row: number;
    //DocType: string;
    //Size: string;
}